import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Fragment, useContext, useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { contextType, LabContext } from "../LabComponent";
import InvestigationForm from "../../InvestigationForm";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {  useQuery } from "react-query";
import { getLabList } from "../../../../services";
import { useParams } from "react-router-dom";
import { InvestigationFormType, LabTableType } from "../../types";
import { TableLoader } from "../../../../../utilis/component/SkeletonLoading/PageLoadSkeleton";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckIcon from "@mui/icons-material/Check";
// import LogComonent from "../../../layouts/LogComonent";
import Close from "@mui/icons-material/Close";
import { EmrContext } from "../../../..";
import useDeleteActivity from "../../../hook/useDeleteActivity";
import HistoryComponent from "../../../layouts/HistoryComponent";
const LabTable = () => {
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(-1);
  const { encounterId } = useParams();
  const { tableData, setEdit, edit, setTableData, refetchLab, setRefetchLab } =
    useContext(LabContext) as contextType;
  const { patientData } = useContext(EmrContext);
  // const { mutate: fetchLab, isLoading: labListLoading } = useMutation(
  //   getLabList,
  //   {
  //     onSuccess: (result) => {
  //       setTableData(result.response.items);
  //       setRefetchLab(false);
  //     },
  //     onError: () => {
  //       setRefetchLab(false);
  //     },
  //   }
  // );

  const {isLoading: labListLoading,refetch} = useQuery(
    ["fetchLabList",refetchLab],
    async () => {
     return getLabList({ encounterId: Number(encounterId) });
    },
    {
      onSuccess: (result) => {
        setTableData(result.response.items);
        setRefetchLab(false);
      },
      onError: () => {
        setRefetchLab(false);
      },
      enabled:Boolean(encounterId),
      refetchOnWindowFocus:false
    }
  );

  // const refetch = () => {
  //   setRefetchLab(true);
  // };

  const { mutate: labDelete, isLoading: labDeleteLoading } =
    useDeleteActivity(refetch);

  const handleEdit = (data: LabTableType) => {
    const update: InvestigationFormType = {
      amount: patientData.pmaster.paymentMode
        ? data.isExcluded
          ? data.labDetailsPshare
          : data.labDetailsInsAmount || data.labDetailsAmt
        : data.labDetailsPshare,
      approvalRequired: data.labDetailsApproval,
      cpt: {
        cptCode: data?.labCptCode,
        cptId: data?.labCptId,
        cptRate: Number(data?.cptRate || 0),
        cptName: data?.labCptName,
        cptDes: data?.labCptDes,
        cptGroupId: 2,
        insCoverage: data?.insCoverage,
      },
      encounterId: encounterId as string,
      IsPerfomed: data?.labDetailsIsPerformed,
      outHouse: data?.labDetailsOutHouse,
      radiologyId: data?.labDetailsId,
      patientshare: patientData.pmaster.paymentMode
        ? data.isExcluded
          ? data.labDetailsAmt
          : data.labDetailsPshare
        : data.labDetailsPshare,
      Quantity: data?.labDetailsQty.toString(),
      Rate: data?.unitRate,
      Reason: data?.labDetailsReason,
      Remark: data?.labDetailsRemarks,
      isExcluded: data?.isExcluded || false,
      createdDate:data?.createdByDate,
      insuranceCoverage:Boolean(data?.insCoverage),
      discount: data.discountAmount || data.discountPercentage || 0,
      discountType: data.discountType || "",
    };
    setEdit(update);
    setShow(false);
  };

  const handleDelete = (item: LabTableType) => {
    labDelete({
      activityId: item.labDetailsId,
      cptGrpId: 2,
      encounterId: parseInt(encounterId as string),
      paymentMode: patientData?.pmaster?.paymentMode,
    });
  };

  const handleClose = () => {
    setEdit(null);
  };

  // useEffect(() => {
  //   if (refetchLab) {
  //     fetchLab({
  //       encounterId: parseInt(encounterId as string),
  //     });
  //   }
  // }, [refetchLab]);

  return (
    <div>
      <Paper>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow
                sx={(theme) => ({
                  backgroundColor: theme.palette.primary.main,
                })}
              >
                {heading.map((heading, index) => (
                  <TableCell
                    sx={(theme) => ({ color: theme.palette.background.paper })}
                    align="left"
                    key={`heading${index}`}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                  {!show && (
                    <div className="w-full flex justify-end items-center p-2 gap-3">
                      <Button
                        color="success"
                        endIcon={<AddCircleIcon />}
                        onClick={() => {
                          setShow(true);
                          setEdit(null);
                        }}
                      >
                        add
                      </Button>
                      <div>
                        {/* <LogComonent  /> */}
                        <HistoryComponent logProps={{field:"labdetails", title:"Lab"}} title="lab" tableprops={tableProps} />
                      </div>
                    </div>
                  )}
                  <Collapse in={show} timeout="auto" unmountOnExit>
                    <Box>
                      <InvestigationForm
                        formType="lab"
                        close={() => {
                          setShow(false);
                        }}
                      />
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
              {tableData?.map((item: LabTableType, index: number) => (
                <Fragment key={`Labtable${index}`}>
                  <TableRow key={index}>
                    <TableCell>
                      <ListItemText
                        primary={`${item.labCptName} (${item.labCptCode})`}
                        secondary={
                          item.labDetailsApproval && (
                            <Typography color="primary" fontSize={".7rem"}>
                              Approval required
                            </Typography>
                          )
                        }
                      ></ListItemText>
                    </TableCell>
                    <TableCell>{Number(item.unitRate || 0).toFixed(2)}</TableCell>
                    <TableCell>{item.labDetailsQty}</TableCell>
                    <TableCell>
                      {item.discountAmount && `${item.discountAmount}`}
                      {item.discountPercentage && `${item.discountPercentage} %`}
                    </TableCell>
                    <TableCell>
                      {Number(patientData.pmaster.paymentMode
                        ? item.isExcluded
                          ? item.labDetailsAmt
                          : item.labDetailsInsAmount || item.labDetailsAmt
                        : item.labDetailsAmt).toFixed(2)}
                    </TableCell>
                    <TableCell>
                      {Number(item.labDetailsPshare).toFixed(2)}
                    </TableCell>
                    <TableCell>
                      {item.labDetailsOutHouse ? (
                        <CheckIcon color="success" />
                      ) : (
                        <RemoveIcon color="error" />
                      )}
                    </TableCell>
                    <TableCell>
                      {item.labDetailsApproval ? (
                        <CheckIcon color="success" />
                      ) : (
                        <RemoveIcon color="error" />
                      )}
                    </TableCell>
                    <TableCell>
                      {item.labDetailsIsPerformed ? (
                        <CheckIcon color="success" />
                      ) : (
                        <RemoveIcon color="error" />
                      )}
                    </TableCell>
                    <TableCell>{item.labDetailsRemarks}</TableCell>
                    <TableCell>{item.labDetailsReason}</TableCell>
                    <TableCell>
                      <div className="flex gap-2">
                        {edit?.radiologyId == item?.labDetailsId ? (
                          <IconButton onClick={handleClose} color="error">
                            <Close />
                          </IconButton>
                        ) : (
                          <IconButton
                            color="primary"
                            onClick={() => {
                              handleEdit(item);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                        <IconButton
                          color="error"
                          onClick={() => {
                            handleDelete(item);
                            setSelected(index);
                          }}
                        >
                          {labDeleteLoading && selected == index ? (
                            <CircularProgress size={15} color="error" />
                          ) : (
                            <DeleteIcon />
                          )}
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                      <Collapse
                        in={
                          Boolean(edit) &&
                          edit?.radiologyId == item?.labDetailsId
                        }
                        timeout="auto"
                        unmountOnExit
                      >
                        <InvestigationForm
                          formType="lab"
                          close={() => {
                            setEdit(null);
                          }}
                        />
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </Fragment>
              ))}
            </TableBody>
          </Table>
          {labListLoading && <TableLoader />}
        </TableContainer>
      </Paper>
    </div>
  );
};

export default LabTable;

const heading = [
  "Item",
  "Unit Rate",
  "Quantity",
  "Discount",
  "Amount",
  "PatientShare",
  "Out house",
  "Approval required",
  "Already performed",
  "Remark",
  "Reason",
  "Options",
];

const tableProps = [
  {
    heading: "Item",
    key: "labCptName",
  },
  {
    heading: "Unit Rate",
    key: "unitRate",
  },
  {
    heading: "Quantity",
    key: "labDetailsQty",
  },
  {
    heading: "Amount",
    key: "labDetailsAmt",
  },
  {
    heading: "PatientShare",
    key: "labDetailsPshare",
  },
  {
    heading: "Remark",
    key: "labDetailsRemarks",
  },
  {
    heading: "Reason",
    key: "labDetailsReason",
  },
];
